import { useRef } from 'react';
import { Button, CenterScreenModal } from '../atoms'
import { 
  useAddUnityFormModalContext,
  useErrorHandlerContext,
  useOpeningElementsControllerContext,
  usePropertyDetailContext,
  useUserLanguage,
} from '@/customHooks'
import { Col, Row } from 'react-grid-system';
import { AddUnitFormControlled } from '../organism/AddUnitFormControlled';
import { UnityDetail } from '@/custom-types';
import { useCreateUnityFromPropertyMutation, useUpdateUnityFromPropertyMutation } from '@/graphql/generated';
import textsData from '@/textData/AddUnitFormModalTexts.json'

export const AddUnitFormModal = () => {
  const userLanguage = useUserLanguage()
  const texts = userLanguage === 'es' ? textsData.es : textsData.en

  const unityDataRef = useRef<UnityDetail | null>(null)
  
  const [createUnity, { loading: createLoading }] = useCreateUnityFromPropertyMutation()
  const [updateUnity, { loading: updateLoading }] = useUpdateUnityFromPropertyMutation()

  const { confirmDialogModalOpen } = useOpeningElementsControllerContext()

  const { unityData, isOpen, closeModal, } = useAddUnityFormModalContext()

  const { property, setProperty } = usePropertyDetailContext()
  
  const { open } = useErrorHandlerContext()

  const OnChangeHandle = (unityData: UnityDetail) => {
    unityDataRef.current = unityData
  }

  const onConfirmHandle = () => {
    if (!unityDataRef.current) return
    
    if (unityData === null) {
      createUnity({ variables: {
        propertyId: property ? property.id : '',
        unityInput: {
          name: unityDataRef.current.name,
          bedSizeOption: unityDataRef.current.bedSizeOption,
          privateBathroom: unityDataRef.current.privateBathroom,
          fan: unityDataRef.current.fan,
          airConditioner: unityDataRef.current.airConditioner,
          currentStatus: unityDataRef.current.currentStatusOption
        }
      }})
      .then((response) => {
        setProperty(undefined)
        closeModal()
        confirmDialogModalOpen({
          title: texts.confirmation.create.title,
          description: `${response.data?.createUnityFromProperty.name ?? ''} ${texts.confirmation.create.description}`,
        })
      })
      .catch((error) => {
        closeModal()
        open(error)
      })
    } 
    else {
      updateUnity({ variables: {
      propertyId: property ? property.id : '',
      unityId: unityData.id,
      unityInput: {
        name: unityDataRef.current.name !== unityData?.name ? unityDataRef.current.name : undefined,
        bedSizeOption: unityDataRef.current.bedSizeOption !== unityData.bedSizeOption ? unityDataRef.current.bedSizeOption : undefined,
        privateBathroom: unityDataRef.current.privateBathroom !== unityData.privateBathroom ? unityDataRef.current.privateBathroom : undefined,
        airConditioner: unityDataRef.current.airConditioner !== unityData.airConditioner ? unityDataRef.current.airConditioner : undefined,
        fan: unityDataRef.current.fan !== unityData.fan ? unityDataRef.current.fan : undefined,
        currentStatus: unityDataRef.current.currentStatusOption !== unityData.currentStatusOption ? unityDataRef.current.currentStatusOption : undefined,
      }
      }})
      .then((response) => {
        setProperty(undefined)
        closeModal()
        confirmDialogModalOpen({
          title: texts.confirmation.update.title,
          description: `${response.data?.updateUnityFromProperty.name ?? ''} ${texts.confirmation.update.description}`
        })
      })
      .catch((error) => {
        closeModal()
        open(error)
      })  
    }
  }
  
  return (
    <CenterScreenModal
      isOpen={isOpen}
      onClose={closeModal}
    >
      <Row>
        <Col>
          <h2>{texts.title}</h2>
        </Col>
      </Row>
      <AddUnitFormControlled
        defaultUnityData={unityData}
        onChange={OnChangeHandle}
      />
      <br />
      <Row justify="center" gutterWidth={32}>
        <Col xs="content">
          <Button secondary onClick={() => closeModal()} disabled={!!updateLoading || !!createLoading}>
            {texts.buttons.cancel}
          </Button>
        </Col>
        <Col xs="content">
          <Button
            onClick={() => onConfirmHandle()}
            isLoading={!!updateLoading || !!createLoading}
          >
            {texts.buttons.confirm}
          </Button>
        </Col>
      </Row>
    </CenterScreenModal>
  )
}
